import React, { memo } from 'react';
import classNames from 'classnames';

import Checkbox from '../../../../helpers/Checkbox';

import style from './style.module.css';

const CriteriaCheckboxComponent = ({ buyer: root, label, name, onChange, disabled }) => (
  <div className={classNames(style.host, 'form-group group-inline ib')}>
    <Checkbox deep="checked" disabled={disabled} label={label} name={name} onChange={onChange} root={root} />
  </div>
);

/** Criteria checkbox component. */
export const CriteriaCheckbox = memo(CriteriaCheckboxComponent);
